
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useTranslation } from 'react-i18next';

interface PersonalInfoFieldsProps {
  register: any;
  errors: any;
}

const PersonalInfoFields: React.FC<PersonalInfoFieldsProps> = ({ register, errors }) => {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="intervieweeName">{t('interview.intervieweeName')}</Label>
        <Input
          id="intervieweeName"
          placeholder={t('form.placeholders.name')}
          {...register('intervieweeName', { required: t('form.validation.required') })}
          className={errors.intervieweeName ? 'border-red-500' : ''}
        />
        {errors.intervieweeName && (
          <p className="text-red-500 text-sm">{errors.intervieweeName.message}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="intervieweeEmail">{t('interview.intervieweeEmail')}</Label>
        <Input
          id="intervieweeEmail"
          type="email"
          placeholder={t('form.placeholders.email')}
          {...register('intervieweeEmail', { 
            required: t('form.validation.required'),
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: t('form.validation.invalidEmail'),
            }
          })}
          className={errors.intervieweeEmail ? 'border-red-500' : ''}
        />
        {errors.intervieweeEmail && (
          <p className="text-red-500 text-sm">{errors.intervieweeEmail.message}</p>
        )}
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="multipleEmails">{t('email.multipleEmails')} ({t('form.optional')})</Label>
        <Input
          id="multipleEmails"
          placeholder={t('form.placeholders.multipleEmails')}
          {...register('multipleEmails')}
        />
        <p className="text-xs text-gray-500 italic">
          {t('email.multipleEmailsHelp')}
        </p>
      </div>
    </>
  );
};

export default PersonalInfoFields;
